import { GovernanceScore } from './GovernanceScore';
import { GovernanceScoreHistory } from './GovernanceScoreHistory';
import GovernanceTimeline from './GovernanceTimeline';
import { History } from 'lucide-react';
import { useLocalization } from '@/hooks/useLocalization';

const AuditTrailView = () => {
  const { t } = useLocalization();
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <History className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-foreground">{t('Audit Trail')}</h1>
          <p className="text-sm text-muted-foreground">{t('Governance score, history, and the full evidence timeline.')}</p>
        </div>
      </div>

      {/* Two panes: the evidence timeline gets the room, the score cards sit beside it
          (two-up when stacked, one column when side by side). */}
      <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_340px] gap-5 items-start">
        <GovernanceTimeline />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-5 xl:sticky xl:top-4">
          <GovernanceScore />
          <GovernanceScoreHistory />
        </div>
      </div>
    </div>
  );
};

export default AuditTrailView;
